import { render, staticRenderFns } from "./purchase-plan-approve-confirmation.vue?vue&type=template&id=c85fef0c&scoped=true&"
import script from "./purchase-plan-approve-confirmation.vue?vue&type=script&lang=js&"
export * from "./purchase-plan-approve-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./purchase-plan-approve-confirmation.vue?vue&type=style&index=0&id=c85fef0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85fef0c",
  null
  
)

export default component.exports